import React, { useId } from "react";

/**
 * Linear labeled progress bar — same structure/classes as Time log submission progress (TimeSheets.css: .ts-tl-stats-progress*).
 * Parent page should import timesheet styles (e.g. TimeSheets.css) where this is used.
 */
const LabeledProgressBar = ({ label, valuePct, labelId: labelIdProp, className }) => {
  const reactId = useId();
  const safeId = reactId.replace(/[^a-zA-Z0-9_-]/g, "");
  const labelId = labelIdProp || `labeled-progress-${safeId}`;
  const pct = Math.min(100, Math.max(0, Number(valuePct) || 0));
  const rounded = Math.round(pct);

  return (
    <div className={["ts-tl-stats-progress", className].filter(Boolean).join(" ")}>
      <div className="ts-tl-stats-progress__head">
        <span className="ts-tl-stats-progress__label" id={labelId}>
          {label}
        </span>
        <span className="ts-tl-stats-progress__pct" aria-hidden="true">
          {pct.toFixed(0)}%
        </span>
      </div>
      <div
        className="ts-tl-stats-progress__track"
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={rounded}
        aria-labelledby={labelId}
      >
        <div className="ts-tl-stats-progress__fill" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
};

export default LabeledProgressBar;
